import styled from '@emotion/styled'
import { Button } from 'components/inputs/Button/Button'

const Section = styled.div`
  flex-shrink: 0;
`

const Header = styled.div`
  position: sticky;
  top: 0;
  z-index: 1;
  background-color: ${({ theme }) => theme.palette.backgroundAccents.darkerBlueish};
`

const NewChatButton = styled(Button)(({ theme }) => ({
  padding: theme.spacing(0.75, 1),
  fontSize: '14px',
}))

export { Section, Header, NewChatButton }
